import { tabletMax, laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { SlidePropertyDetails } from '../home/HomeHeader.style';
import { Heading } from '../typography';

export const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  padding: 0 15px;
  margin: 25px auto;

  @media (${laptopMediumMax}) {
    ${Heading} {
      font-size: 24px;
    }
  }

  @media (${tabletMax}) {
    padding: 0 10px;
    ${Heading} {
      font-size: 20px;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 480px;
  position: relative;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`;

export const ImageLink = styled.a<{ $active: boolean }>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
`;

export const ImageBox = styled.img<{ active: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 1s;
  transition-delay: 2s;

  ${(props) =>
    props.active &&
    css`
      opacity: 1;
      transition-delay: 0s;
    `}
`;

export const ImagePropertyDetails = styled(SlidePropertyDetails)<{ active: boolean }>`
  opacity: 0;
  transition: opacity 0.5s;
  transition-delay: 0.5s;

  ${(props) =>
    props.active
      ? css`
          opacity: 1;
          transition-delay: 0s;
        `
      : css`
          pointer-events: none;
        `}
`;
